import { Component, OnInit, Input } from '@angular/core';

import { TransactionInvoiceService } from 'src/app/pages/transaction/services/transaction-invoice.service';

import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
import { MultiLanguageService } from 'src/app/core/services/multi-language.service';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CostFormAdminService } from '../../../../services/cost-form-admin.service';

@Component({
  selector: 'tr.transaction-cost-item-admin',
  templateUrl: './cost-item-admin.component.html',
  styleUrls: ['./cost-item-admin.component.scss']
})
export class CostItemAdminComponent implements OnInit {
  @Input('cost') cost;
  @Input('invoice') invoice;

  canEdit: boolean = false;

  selected: boolean = false;
  qty: any = 0;
  manualAmount = 0;
  total: any = 0;
  placeholder: any;
  isRequired: boolean = false;
  isInformative: boolean = false;

  constructor(
    private mainService: CostFormAdminService,
    private transactionService: TransactionService,
    public multiLanguageService: MultiLanguageService,
    public dynamicFormService: DynamicFormService,
    public authService: AuthService,
  ) {
  }

  ngOnInit() {

      if(!this.cost.IsInformative && !this.cost.IsRequired){
   
  
      }
      
  
      if(this.cost.IsInformative){
        this.isInformative = true;
      }
      if(this.cost.IsRequired){
        this.selected = true;
        this.isRequired = true;
        this.qty = this.cost.Qty;
  
        this.calculate(null);
      } 
    this.cost.requiresMininum = true;
    this.mainService.minRequiredCosts.push(this.cost);

    this.qty = this.cost.Qty;
    this.selected = (this.qty ? true : false);


    this.calculate(null);
    // }


    this.canEdit = true;
  }

  calculate(valueType) {
    console.log('total: ' + this.total);
    if (this.selected && this.cost.requiresMininum) {

      if (valueType == 'checkbox' && this.mainService.minimumCostSelectedCount < this.mainService.minRequiredCosts.length) {
        this.mainService.minimumCostSelectedCount += 1;
      }

      this.mainService.minimumCostsAdded = false;

      if (this.qty > 0 || this.cost.FixedAmount > 0) {
        this.mainService.minimumCostsAdded = true;
      }
    }
    if (!this.selected && this.cost.requiresMininum) {

      this.mainService.minimumCostsAdded = false;
      this.mainService.minimumCostSelectedCount -= 1;

      if (valueType == 'checkbox' && this.mainService.minimumCostSelectedCount > 0) {
        this.mainService.minimumCostsAdded = true;
      }

    }
    console.log('this.mainService.minimumCostSelectedCount: ' + this.mainService.minimumCostSelectedCount);

    if (
      (this.qty > 0 || this.cost.FixedAmount > 0 || this.cost.IsManual)
      &&
      this.selected
    ) {

      if (this.cost.FixedAmount > 0) {
        this.total = this.cost.FixedAmount;
      } 

      if (this.cost.FixedAmount <= 0) {
        this.total = this.qty * this.cost.Amount;
      }

      if (this.cost.IsManual) {
        this.cost.Amount = this.manualAmount;
        this.qty = 1;
        this.total = this.manualAmount;
      }

      this.mainService.manageCost({
        cost: this.cost,
        qty: (this.cost.FixedAmount > 0) ? 1 : this.qty
      });
    } else {
      this.qty = 0;
      this.mainService.removeCost(this.cost);
    }

    this.mainService.setInvoiceTotal();
  }
}
